import React from 'react';

type PDFIconProps = {
  width?: string;
  height?: string;
  color?: string;
  style?: React.CSSProperties;
};

function PDFIcon({
  width = '40',
  height = '53',
  color = '#6267AC',
}: PDFIconProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 40 53'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M0 8.00001C0 3.58173 3.58172 0 8 0H26.8376L31.9658 4.78632L40 11.7949V44.6496C40 49.0679 36.4183 52.6496 32 52.6496H8C3.58172 52.6496 0 49.0679 0 44.6496V8.00001Z'
        fill='#E2574C'
      />
      <path
        d='M26.7259 7.61682L26.8379 0L40.0003 11.7949L30.6742 11.6753C28.4623 11.6469 26.6934 9.82866 26.7259 7.61682Z'
        fill='#B53629'
      />
      <path
        d='M29.6685 24.0447C30.1471 24.0447 30.3814 23.6276 30.3814 23.2233C30.3814 22.8047 30.1371 22.4004 29.6685 22.4004H26.9428C26.4099 22.4004 26.1128 22.8418 26.1128 23.329V30.0275C26.1128 30.6247 26.4528 30.9561 26.9128 30.9561C27.37 30.9561 27.7114 30.6247 27.7114 30.0275V28.189H29.36C29.8715 28.189 30.1272 27.7704 30.1272 27.3547C30.1272 26.9476 29.8715 26.5432 29.36 26.5432H27.7114V24.0447H29.6685ZM20.4556 22.4004H18.4613C17.9199 22.4004 17.5355 22.7718 17.5355 23.3232V30.0333C17.5355 30.7175 18.0884 30.9318 18.4841 30.9318H20.577C23.0541 30.9318 24.6898 29.3019 24.6898 26.7861C24.6885 24.1261 23.1485 22.4004 20.4556 22.4004ZM20.5514 29.2776H19.3356V24.0547H20.4314C22.09 24.0547 22.8114 25.1676 22.8114 26.7033C22.8114 28.1405 22.1027 29.2776 20.5514 29.2776ZM13.2456 22.4004H11.2699C10.7113 22.4004 10.3999 22.7689 10.3999 23.329V30.0275C10.3999 30.6247 10.757 30.9561 11.237 30.9561C11.7169 30.9561 12.0741 30.6247 12.0741 30.0275V28.0718H13.3126C14.8412 28.0718 16.1026 26.9889 16.1026 25.2475C16.1028 23.5433 14.8857 22.4004 13.2456 22.4004ZM13.2128 26.5005H12.0742V23.9733H13.2128C13.9157 23.9733 14.3628 24.5218 14.3628 25.2376C14.3614 25.9519 13.9157 26.5005 13.2128 26.5005Z'
        fill='white'
      />
    </svg>
  );
}

export default PDFIcon;
